import { Box, Button, Heading, Level } from "react-bulma-components";
import holorayLogo from "../../assets/images/png/HoloRay_Logo_256.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneSlash } from "@fortawesome/free-solid-svg-icons";
import ChannelConnection from "../../js/connection/ChannelConnection";
import LeaveChannelModal from "./LeaveChannelModal";
import { useNavigate } from "react-router";

export default function ChannelBanner({
    connection
}: {
    connection: ChannelConnection;
}) {
    const navigate = useNavigate();

    function onLeaveCallClick() {
        const confirmLeave = document.getElementById("confirmLeave");
        if (confirmLeave) {
            confirmLeave.classList.toggle("is-active");
        }
    }

    return (
        <>
            <Box>
                <Level breakpoint="mobile">
                    <Level.Side style={{ gap: 10 }}>
                        <Level.Item>
                            <img
                                style={{ maxHeight: 50 }}
                                alt="HOLORAY"
                                src={holorayLogo}
                            />
                        </Level.Item>

                        <Level.Item>
                            <div
                                style={{
                                    width: 1,
                                    height: 50,
                                    backgroundColor: "gray"
                                }}
                            />
                        </Level.Item>

                        <Level.Item>
                            <Heading subtitle>
                                {connection.channel.getId()}
                            </Heading>
                        </Level.Item>
                    </Level.Side>

                    <Level.Side align="right">
                        <Button
                            color="danger"
                            rounded
                            onClick={onLeaveCallClick}>
                            <FontAwesomeIcon
                                icon={faPhoneSlash}
                                style={{ marginRight: 10 }}
                            />
                            Leave
                        </Button>
                    </Level.Side>
                </Level>
            </Box>
            <LeaveChannelModal
                title="Leave the channel?"
                onSuccess={() => navigate("/")}
                onCancel={onLeaveCallClick}
            />
        </>
    );
}
